import {
  apiUrl,
  getList,
  get,
  postAction,
  deleteRecord,
  getAll,
  upload,
  putAction,
  deleteAction,
  download,
} from './apiUtils';
import type { ApiListParamsWithUnderscores } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';

const baseUrl = apiUrl + '/skuPrices/';

export function getAllSKUPrices(): Promise<unknown> {
  return getAll(baseUrl);
}

export function getAllDraftSKUPrices(): Promise<unknown> {
  return getAll(`${baseUrl}draft`);
}

export function getSKUPrices(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}search`, params);
}

export function getDraftSKUPrices(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}draft/search`, params);
}

export function getSKUPriceById(
  skuId: string,
  currencyId: string
): Promise<unknown> {
  return get(`${baseUrl}?skuId=${skuId}&currencyId=${currencyId}`);
}

export function saveSKUPrice(
  skuId: string,
  currencyId: string,
  price: unknown
): Promise<unknown> {
  return postAction(baseUrl, { skuId, currencyId, price });
}

export function deleteSKUPrices(
  skuId: string,
  currencyId: string
): Promise<unknown> {
  return deleteRecord(baseUrl, `${skuId}/${currencyId}`);
}

export function deleteAllSKUPrices(): Promise<unknown> {
  return deleteAction(`${baseUrl}all`);
}

export function uploadPrices(record: unknown): Promise<unknown> {
  return upload(`${baseUrl}upload`, record);
}

export function exportPrices(isDraft: boolean): Promise<void> {
  return download(`${baseUrl}export?isDraft=${isDraft}`);
}

export function publishDraft(): Promise<unknown> {
  return putAction(`${baseUrl}draft/publish`, {});
}
